import { NgModule } from '@angular/core';
import { CommonModule, CurrencyPipe } from '@angular/common';
import { ProductMostrarioComponent } from './product-mostrario/product-mostrario.component';
import { ProductPresentationComponent } from './product-presentation/product-presentation.component';
import { IonicModule } from '@ionic/angular';
import { ComponentsModuleModule } from 'src/app/components/components-module.module';
import { FormsModule } from '@angular/forms';
import { PipeModule } from 'src/app/pipes/pipe-module.module';
import { TranslateModule } from '@ngx-translate/core';
import { GroupComponent } from './group/group.component';
import { GeneralesComponentsModule } from 'src/app/generales-components/generales-components.module';
import { ComponentsCompraModule } from '../../vista-compra/components-compra/components-compra.module';
import { SkeletonDetailComponent } from './skeleton-detail/skeleton-detail.component';
import { ProductsComponentModule } from 'src/app/products-component/products-component.module';

const declarations = [
  ProductMostrarioComponent,
  ProductPresentationComponent,
  GroupComponent,
  SkeletonDetailComponent,
];

@NgModule({
  declarations: declarations,
  imports: [
    CommonModule,
    IonicModule,
    ComponentsModuleModule,
    FormsModule,
    PipeModule,
    TranslateModule,
    GeneralesComponentsModule,
    ComponentsCompraModule,
    ProductsComponentModule,
  ],
  providers: [CurrencyPipe],
  exports: declarations,
})
export class ComponentsModule {}
